
const Popup = {
	open: function( url, width, height ) {
		const newwindow = window.open( url, 'name', 'height=' + height + ', width=' + width );
		if ( window.focus ) {
			newwindow.focus();
		}
	}
};

export { Popup };
